import { useNavigate } from 'react-router';
import '../App.css';

import { PlusCircledIcon } from '@radix-ui/react-icons';
import { useEffect, useState } from 'react';
import { MyBunniesDatatable } from '../components/datatables/myBunniesDatatable';
import ImportBunniesDialog from '../components/dialogs/importBunniesDialog';
import { Button } from '../components/ui/button';
import api from '../lib/api';

function MyBunnies() {
    const navigate = useNavigate();
    const [bunnies, setBunnies] = useState([]);
    const [isLoading, setIsLoading] = useState(true)

    const fetchBunnies = async () => {
        try {
            const response = await api.get(`https://skhrf-api.cmdigital.se/v1/bunnies/available`);
            const bunnies = response.data.map(bunny => ({
                ...bunny,
            }));

            setBunnies(bunnies);
        } catch (error) {
            console.error('Error fetching bunnies:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchBunnies();
    }, []);

    return (
        <div className='flex w-full items-center justify-center'>
            <div className='flex w-5/6 sm:w-3/4 flex-col py-6 gap-3'>
                <div className='grid grid-cols-1 lg:grid-cols-2 items-start lg:gap-6'>
                    <div>
                        <h1 className='font-medium text-2xl'>Mina kaniner</h1>
                        <p className='text-muted-foreground text-sm'>Här visas både dina egna kaniner och de du har lånat. Kaniner som du har ansökt om hos förbundet visas också här, och du har möjlighet att återkalla din ansökan innan den blir godkänd. Du kan också importera dina kaniner från tidigare system genom att ange ditt medlemsnummer.</p>
                    </div>
                    <div className='grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 pt-3'>
                        <Button className='xl:col-span-2' onClick={() => navigate(`/add-bunny`)}>
                            <PlusCircledIcon className='mr-3' />
                            Lägg till kanin
                        </Button>
                        <ImportBunniesDialog fetchBunnies={fetchBunnies} />
                    </div>
                </div>
                <MyBunniesDatatable bunnies={bunnies} fetchBunnies={fetchBunnies} isLoading={isLoading} />
            </div>
        </div>
    );
}

export default MyBunnies;
